





























	import Vue from 'vue';
    import MenuItemComp from './MenuItemComp.vue';
    import NameComp from "./NameComp.vue";
    import _icons from '../../services/icons';

    export default Vue.extend({
        name: "MenuItemListComp",
        components: {
            NameComp,
            MenuItemComp
        },
        data: () => ({
            menuItems: [
                { id: 0, icon: 'home', title: 'Home', route: '/' },
                { id: 1, icon: 'explore', title: 'Meine Raids', route: '/raids' },
                { id: 2, icon: 'account_circle', title: 'Profil', route: '/profil' },
                { id: 3, icon: 'settings', title: 'Einstellungen', route: '/einstellungen' },
                { id: 4, icon: 'help', title: 'Hilfe', route: '/help' },
                //{ id: 3, icon: 'beenhere', title: 'Skills', route: '/skills'},
            ]
        }),
        computed: {
            icon: function(): string {
                if (this.user.discord) {
                    return this.user.discord.avatar;
                } else {
                    return _icons.miscIcon('raid');
                }
            },
            user: function(): any {
                return this.$vStore.getters.loggedInUser;
            }
        },
        methods: {
            toHomescreen: function(): void {
                this.$router.push('/');
            },
        }
    })
